@if (spin.state$ | async; as state) {
  @if (state.loading) {
    <div class="spinner-overlay" #voile popover="manual">
      <div class="spinner-card">
        <mat-spinner diameter="50" strokeWidth="4"></mat-spinner>
        @if (state.message) {
          <div class="spinner-message">
            {{ state.message }}
          </div>
        }
      </div>
    </div>
  }
}


